import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { installAdminPreviewGuard } from "./lib/adminPreview";
import "./index.css";

// Admin 사이드 패널 미리보기에서는 일반 링크·폼의 외부 이동을 막는다(스크롤·펼치기·복사는 유지).
installAdminPreviewGuard();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
